import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { submit } from 'redux-form'
import DetailsFields from './details'
import AmenityFields from './amenities'
import OpenningFields from './opening'
import ImagesFields from './images-fields'

const VenueFields = ({ dispatch, form }) => {
  return (
    <>
      <DetailsFields form={form} />
      <ImagesFields form={form} />
      <AmenityFields />
      <OpenningFields form={form} />
      <div className="flex items-center justify-center">
        <button
          onClick={() => dispatch(submit(form))}
          className={`${'w-full md:w-2/12 text-white px-2 py-3 rounded-b-lg md:rounded-lg focus:outline-none bg-primary-orange'}`}
        >
          Save Venues
        </button>
      </div>
    </>
  )
}

VenueFields.propTypes = {
  dispatch: PropTypes.func,
  form: PropTypes.string,
}

export default connect()(VenueFields)
